import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';

export default function ExtremeDuty527Page() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <div className="bg-[#f5f5f5] py-4">
        <div className="container mx-auto px-4">
          <h5 className="text-sm text-[#333333]">
            <Link to="/" className="hover:underline">Home</Link> / 527 EXTREME DUTY
          </h5>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column - Images */}
          <div>
            <div className="mb-4">
              <img 
                              src="/images/527_Hero_02.jpg" 
                alt="527 Extreme Duty" 
                className="w-full rounded-lg"
              />
            </div>
            

            
            
          </div>

          {/* Right Column - Product Info */}
          <div>
            
            <h1 className="text-4xl font-bold text-[#333333] mb-4">527 EXTREME DUTY</h1>
            <h4 className="text-xl text-[#666666] mb-2">Model: 527000</h4>
            <h4 className="text-xl text-[#666666] mb-6">Weight: 528 lbs</h4>

            <div className="prose max-w-none mb-8">
              <h2 className="text-2xl font-bold text-[#333333] mb-4">Tree Puller Attachment for Skid Steers</h2>
              <p className="text-[#666666] mb-4">
                The 527 EXTREME DUTY is a powerful and reliable tree puller attachment built for demanding jobs. Designed for use with skid steers, this heavy duty tree puller is engineered to remove entire trees—roots and all—while offering exceptional value and versatility for landowners, farmers, and contractors.
              </p>
              <p className="text-[#666666] mb-4">
                Compared to our 537 ELIMINATOR, the 527 is slightly lighter at 528 lbs but still delivers serious pulling power with extended blades and a large root ripper for deep digging and root cutting. It's ideal for those who need a rugged, efficient tree puller attachment without the added weight or saw feature found on the 537 model.
              </p>
              <p className="text-[#666666] mb-4">
                The 527 features sharp, serrated jaws for a secure grip and 8" wide spade points to break up soil and tear through roots. Its open-tip design also makes it effective for pulling posts, stakes, and even moving heavy rocks.
              </p>
              <p className="text-[#666666]">
                If you're looking for a reliable heavy duty tree puller that's tough, efficient, and built for real-world work, the 527 EXTREME DUTY tree puller attachment delivers serious performance without compromise!
              </p>
            </div>

            <hr className="my-8 border-[#e5e5e5]" />

            {/* Features Accordion */}
            <div className="mb-8">
              <details className="group" open>
                <summary className="flex justify-between items-center cursor-pointer list-none py-4 border-b border-[#e5e5e5]">
                  <span className="text-lg font-bold text-[#333333]">FEATURES</span>
                  <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="py-4">
                  <ul className="list-disc pl-6 space-y-2 text-[#666666]">
                    <li>Extended blade length by 12" for deeper root access</li>
                    <li>Large root ripper for enhanced cutting performance</li>
                    <li>30" jaw opening for medium to large trees</li>
                    <li>Reversed 8" wide spade points for improved soil penetration</li>
                    <li>Open blade spacing allows dirt and debris to pass through</li>
                    <li>Hydraulic hose holder for better hose management (TAMEit not included)</li>
                    <li>Open-tip design minimizes damage when pulling "T" posts</li>
                    <li>Extra-long 90° blade teeth for strong, stable grip</li>
                  </ul>
                </div>
              </details>
            </div>

            {/* CTA Buttons */}
            <div className="space-y-4">
              <a 
                href="/contact" 
                className="block w-full bg-[#d4af37] text-white text-center py-3 px-6 font-bold hover:bg-[#c19b2a] transition-colors"
              >
                Call Us Now
              </a>
              
                
              
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-16 bg-[#f5f5f5] p-8 rounded-lg">
          <h3 className="text-2xl font-bold text-[#333333] mb-6">Frequently Asked Questions</h3>
          <div className="space-y-4">
            <div>
              <p className="font-bold text-[#333333] mb-2">Q: How does the 527 EXTREME DUTY compare to the 537 ELIMINATOR tree puller attachment?</p>
              <p className="text-[#666666]">A: The 527 EXTREME DUTY is a lighter tree puller attachment at 528 lbs but still offers powerful performance with extended blades and a root ripper for aggressive digging. Unlike the 537 ELIMINATOR, it does not include a built-in saw feature, making it a simpler, more streamlined option for users who don't need to cut larger trunks.</p>
            </div>
            <div>
              <p className="font-bold text-[#333333] mb-2">Q: What type of work is the 527 EXTREME DUTY best suited for?</p>
              <p className="text-[#666666]">A: This heavy duty tree puller is ideal for removing medium to large trees by the roots, clearing brush, pulling fence posts, and even relocating rocks or stakes. It's a great choice for landowners, farmers, and contractors who need a versatile attachment for routine clearing and maintenance.</p>
            </div>
            <div>
              <p className="font-bold text-[#333333] mb-2">Q: Is the 527 EXTREME DUTY compatible with all skid steers?</p>
              <p className="text-[#666666]">A: Yes, the 527 is designed to fit most skid steers with a universal quick attach system. It's a rugged and reliable tree puller attachment that integrates easily into your existing equipment setup.</p>
            </div>
          </div>
        </div>

        

        {/* Disclaimer */}
        <div className="mt-12 bg-[#f5f5f5] p-8 rounded-lg text-center">
          <h3 className="text-xl font-bold text-[#333333] mb-4">SOLVING TREE & BRUSH PROBLEMS SINCE 1992!</h3>
          <p className="text-[#666666]">
            All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
          </p>
        </div>
      </div>

     
    </div>
  );
}